// Mock data for RDK Services LLC App Development Website

export const companyInfo = {
  name: "RDK Services LLC",
  tagline: "Crafting Digital Experiences That Move People",
  description: "We build innovative mobile applications that transform ideas into powerful digital solutions. From health & wellness to AI-powered creativity, our apps are designed to make a difference.",
  email: "cs@myrdkllc.com",
  address: "15810 Gale Ave. Suite 285. City of Industry, CA 91745"
};

export const apps = [
  {
    id: 1,
    name: "Drayly",
    appKey: "drayly",
    tagline: "Logistics, Simplified.",
    description: "A smart logistics and drayage platform that streamlines container moves, dispatch, and delivery tracking — keeping freight on schedule from port to door.",
    category: "Logistics",
    image: "https://image.thum.io/get/width/1200/crop/800/https://drayly.com",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "https://drayly.com",
    featured: true,
    stats: {
      downloads: "Live",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 2,
    name: "Slidecon",
    appKey: "slidecon",
    tagline: "Slides for Every Message.",
    description: "An AI-powered slideshow generator for churches, educators, and presenters — turn your message into beautiful, ready-to-present slides in minutes.",
    category: "Productivity",
    image: "https://image.thum.io/get/width/1200/crop/800/https://slide-con.com",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "https://slide-con.com",
    featured: true,
    stats: {
      downloads: "Live",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 3,
    name: "Lumera",
    appKey: "lumera",
    tagline: "Understand God's Word Like Never Before.",
    description: "An AI-powered Bible companion — find truth instantly, explore Scripture with clarity, and grow in understanding through intelligent study and devotional guidance.",
    category: "Faith",
    image: "https://image.thum.io/get/width/1200/crop/800/https://biblelumera.com",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "https://biblelumera.com",
    featured: false,
    stats: {
      downloads: "Live",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 4,
    name: "Vydlix",
    appKey: "vydlix",
    tagline: "Your Video Universe.",
    description: "A next-generation video platform for discovering, streaming, and sharing short-form content with a feed that learns what you love.",
    category: "Entertainment",
    image: "https://static.prod-images.emergentagent.com/jobs/6f25869b-d2a2-40b9-94c5-9615cea4300f/images/7abccdc931c8198cac8648d9a0f3c275319179bae7a50cf5cf9e6fbb8f2df70c.png",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "#",
    featured: false,
    stats: {
      downloads: "Soon",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 5,
    name: "Ideaqube",
    appKey: "ideaqube",
    tagline: "Where Ideas Take Shape.",
    description: "A collaborative idea and innovation hub to capture, organize, and develop concepts — turning scattered thoughts into actionable plans.",
    category: "Productivity",
    image: "https://static.prod-images.emergentagent.com/jobs/6f25869b-d2a2-40b9-94c5-9615cea4300f/images/dde9420a21e4ae8c44e47d5f38c324ba12cad5f999ab08c037484d5dccc7c9f2.png",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "#",
    featured: false,
    stats: {
      downloads: "Soon",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 6,
    name: "Arkmusic",
    appKey: "arkmusic",
    tagline: "Create Music Like Never Before",
    description: "AI-powered music creation platform featuring voice generation, stem separation, an extensive songs library, and engaging musical games. Unleash your inner artist.",
    category: "Music & Audio",
    image: "https://static.prod-images.emergentagent.com/jobs/6f25869b-d2a2-40b9-94c5-9615cea4300f/images/979727bd001d0ef90bb0d99a82d62dbf98db490d1b05a3b16a9916f80cd41ffe.png",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "#",
    featured: true,
    stats: {
      downloads: "Soon",
      rating: "New",
      reviews: "0"
    }
  },
  {
    id: 7,
    name: "Bienify",
    appKey: "bienify",
    tagline: "Feel Good, Every Day.",
    description: "A wellness companion for mindful living — track habits, mood, and self-care routines designed to help you feel your best, every day.",
    category: "Health & Fitness",
    image: "https://static.prod-images.emergentagent.com/jobs/6f25869b-d2a2-40b9-94c5-9615cea4300f/images/da6d28a0ad88de40e1763b2a6a378a149e1441b90462a13ec8c6e08e8adff3a1.png",
    appStoreUrl: "#",
    playStoreUrl: "#",
    websiteUrl: "#",
    featured: false,
    stats: {
      downloads: "Soon",
      rating: "New",
      reviews: "0"
    }
  }
];

export const services = [
  {
    id: 1,
    title: "Mobile App Development",
    description: "Native and cross-platform apps built with cutting-edge technology for iOS and Android.",
    icon: "Smartphone"
  },
  {
    id: 2,
    title: "UI/UX Design",
    description: "Beautiful, intuitive interfaces that users love and keep coming back to.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "AI Integration",
    description: "Intelligent features powered by machine learning and artificial intelligence.",
    icon: "Brain"
  },
  {
    id: 4,
    title: "Backend Solutions",
    description: "Scalable, secure server infrastructure that grows with your application.",
    icon: "Server"
  }
];

export const heroImage = "https://images.unsplash.com/photo-1535957998253-26ae1ef29506";
